import { motion } from 'framer-motion';

export function VsBadge() {
  return (
    <div className="vs-badge">
      <motion.div
        className="absolute inset-0 rounded-full"
        style={{
          background: 'conic-gradient(from 0deg, hsl(var(--opponent)), hsl(var(--primary)), hsl(var(--player)), hsl(var(--opponent)))',
        }}
        animate={{ rotate: 360 }}
        transition={{ duration: 4, repeat: Infinity, ease: 'linear' }}
      />
      <div className="vs-badge-inner">
        VS
      </div>
    </div>
  );
}
